module.exports = __webpack_public_path__ + "static/media/card5_13.dbf6394d.png";